import { useState, useMemo, useCallback, useEffect } from "react";

import axios from 'axios';

import { APP_PREFIX } from "@/utils/constants";

const DEFAULT_DELAY = 1 // minutes
const NOT_NOW_DELAY = 60 // minutes
const URL = `${process.env.NODE_ENV === 'development' ? '' : APP_PREFIX}/static/version.json`

export const hookGlobalAppVersionFactory = () => () => {
  const [timeoutId, setTimeoutId] = useState(null)
  const [timestamp, setTimestamp] = useState('')
  const [version, setVersion] = useState('')
  const [updated, setUpdated] = useState(true)
  const [delay, setDelay] = useState(DEFAULT_DELAY)

  const fetch = useCallback(async () => {
    try {
      const { data } = await axios({
        method: 'GET', url: URL,
        headers: { 'Cache-Control': 'no-cache' },
      })
      return data?.version
    } catch (error) {
      return null
    }
  }, [])

  const handleLoop = useCallback(async () => {
    const versionFetched = await fetch()
    if (versionFetched) {
      if (!version) {
        setVersion(versionFetched)
      } else {
        const updated = versionFetched === version
        setUpdated(updated)
      }
    }
    setTimestamp(Date.now() + delay * 60 * 1000)
  }, [fetch, version, delay])

  useEffect(() => {
    handleLoop()
  }, [])

  useEffect(() => {
    setTimeoutId(id => {
      clearTimeout(id)
      return setTimeout(handleLoop, delay * 60 * 1000)
    })
  }, [handleLoop, timestamp, delay])

  useEffect(() => {
    window.userenroll = { version, updated, delay, timestamp }
  }, [version, updated, delay, timestamp])

  return useMemo(() => ({
    versionControl: {
      DEFAULT_DELAY,
      NOT_NOW_DELAY,
      timestamp,
      updated,
      setDelay,
    },
  }), [timestamp, updated, setDelay])
}
